import { createSlice } from '@reduxjs/toolkit';

/**
 * Global "open a detail panel over whatever screen I'm on" state.
 *
 * Mounted ONCE at AppShell level (sibling to <Outlet/>), so opening a patient or invoice
 * from anywhere in the CRM (global search, Today's Tasks, call logs, the calendar popover,
 * etc.) never navigates away and never unmounts the page underneath — that page's filters,
 * search term and scroll position are simply untouched, because it was never torn down.
 *
 * Pages that open these details NATIVELY (PatientsPage, BillingPage's own register) keep
 * their own local open/close state as before — this slice is only for cross-page opens.
 */
const initialState = {
  patientId: null,
  invoiceId: null,
};

const detailPanelSlice = createSlice({
  name: 'detailPanel',
  initialState,
  reducers: {
    openPatientDetail: (state, action) => {
      state.patientId = action.payload;
    },
    closePatientDetail: (state) => {
      state.patientId = null;
    },
    openInvoiceDetail: (state, action) => {
      state.invoiceId = action.payload;
    },
    closeInvoiceDetail: (state) => {
      state.invoiceId = null;
    },
  },
});

export const { openPatientDetail, closePatientDetail, openInvoiceDetail, closeInvoiceDetail } = detailPanelSlice.actions;
export const selectOpenPatientId = (s) => s.detailPanel.patientId;
export const selectOpenInvoiceId = (s) => s.detailPanel.invoiceId;
export default detailPanelSlice.reducer;
